import { CatalogEntry as CatalogEntrySchema } from "schemas/catalogs";
import querystring from "querystring";

export const updateQuery = (catalogId, entryId, delta = {}) => ({
    url: `/api/v3.1/catalog/${catalogId}/entry/${entryId}`,
    body: delta,
    schema: CatalogEntrySchema,
    options: {
        method: "PATCH",
    },
    optimisticUpdate: {
        entries: (prevEntities) => {
            const entry = prevEntities[entryId];
            if (!entry) {
                return prevEntities;
            }
            return {
                ...prevEntities,
                [entryId]: entry.merge(delta),
            };
        },
    },
});

export const sortQuery = (catalogId, entryId, before) => ({
    url: `/api/v3.0/catalog/${catalogId}/entry/${entryId}/sort`,
    body: { before },
    schema: CatalogEntrySchema,
    options: {
        method: "PATCH",
    },
});

export const createQuery = (catalogId, tempId, data) => ({
    url: `/api/v3.1/catalog/${catalogId}/entries`,
    body: data,
    schema: CatalogEntrySchema,
    force: true,
    options: {
        method: "POST",
    },
});

export const deleteQuery = (catalogId, entryId) => ({
    url: `/api/v3.1/catalog/${catalogId}/entry/${entryId}`,
    update: {
        entries: (prevEntities) => {
            delete prevEntities[entryId];
            return {
                ...prevEntities,
            };
        },
    },
    options: {
        method: "DELETE",
    },
});

export const bulkDeleteQuery = (catalogId, entries) => ({
    url: `/api/v3.1/catalog/${catalogId}/entries?${querystring.stringify(entries)}`,
    options: {
        method: "DELETE",
    },
});
